import { handleActions } from "redux-actions";

const brokerInviteModalReducer = handleActions(
  {
    BROKER_INVITE_MODAL: {
      CLOSE: () => ({
        isBrokerInviteModalOpen: false,
      }),
      OPEN: () => ({
        isBrokerInviteModalOpen: true,
      }),
    },
  },
  {},
  { namespace: "_" }
);

export default brokerInviteModalReducer;
